export default __webpack_public_path__ + "static/media/calendar.cdfa3d9c.svg";